export default "__VITE_ASSET__BEwM5dz6__"